import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find-index.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { computed, reaction, runInAction } from "mobx";
import Base from "./Base";
import { WineLockerModel } from "./models/WineLockerModel";
import DPServices, { WineLockerTypes } from "@dp/services";
import { handle } from "@dp/common";
import Errors, { ERROR_STRINGS } from "./Errors";
var WineLocker = (_class = /*#__PURE__*/function (_Base) {
  _inherits(WineLocker, _Base);

  var _super = _createSuper(WineLocker);

  function WineLocker(rootStore) {
    var _this;

    _classCallCheck(this, WineLocker);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "wineLockerModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "_showWineLockerOnboarding", null);

    _this.rootStore = rootStore;
    _this.wineLockerModel = new WineLockerModel();
    runInAction(function () {
      _this.appMessages = rootStore.appMessages;
    }); // makeObservable(this);

    return _this;
  }

  _createClass(WineLocker, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.wineLockerModel.reset();
                return _context3.abrupt("return", Promise.resolve());

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this;

      reaction(function () {
        var _this2$rootStore, _this2$rootStore$menu, _this2$rootStore$menu2;

        return {
          currentRestaurant: (_this2$rootStore = _this2.rootStore) === null || _this2$rootStore === void 0 ? void 0 : (_this2$rootStore$menu = _this2$rootStore.menuList) === null || _this2$rootStore$menu === void 0 ? void 0 : (_this2$rootStore$menu2 = _this2$rootStore$menu.orderSettingsModel) === null || _this2$rootStore$menu2 === void 0 ? void 0 : _this2$rootStore$menu2.currentRestaurant
        };
      }, function (data) {
        if (data.currentRestaurant) {
          _this2.wineLockerModel.wineLockersByOwner = null;
        }
      });
    }
  }, {
    key: "shouldShowWineLockerOnboarding",
    value: function () {
      var _shouldShowWineLockerOnboarding = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var firstVisit;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this._showWineLockerOnboarding === null || this._showWineLockerOnboarding === undefined)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return this.rootStore.platformUtil.getFromLocalStorage("WINE_LOCKER_FIRST_VISIT");

              case 3:
                firstVisit = _context4.sent;

                if (firstVisit && firstVisit === "N") {
                  this._showWineLockerOnboarding = false;
                } else {
                  this._showWineLockerOnboarding = true;
                }

              case 5:
                return _context4.abrupt("return", this._showWineLockerOnboarding);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function shouldShowWineLockerOnboarding() {
        return _shouldShowWineLockerOnboarding.apply(this, arguments);
      }

      return shouldShowWineLockerOnboarding;
    }()
  }, {
    key: "setWineLockerFirstVisit",
    value: function () {
      var _setWineLockerFirstVisit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(val) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this._showWineLockerOnboarding = val;
                this.rootStore.platformUtil.saveInLocalStorage("WINE_LOCKER_FIRST_VISIT", val ? "true" : "N");
                return _context5.abrupt("return");

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setWineLockerFirstVisit(_x) {
        return _setWineLockerFirstVisit.apply(this, arguments);
      }

      return setWineLockerFirstVisit;
    }()
  }, {
    key: "guestAuthentication",
    value: function () {
      var _guestAuthentication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$rootStore, _this$rootStore$user, _this$rootStore$user$, _this$rootStore2, _this$rootStore2$user, _this$rootStore2$user2, _this$rootStore3, _this$rootStore3$user, _this$rootStore3$user2, _this$rootStore4, _this$rootStore4$user, _this$rootStore4$user2, _this$rootStore5, _this$rootStore5$user, _this$rootStore5$user2, _this$rootStore6, _this$rootStore6$user, _this$rootStore6$user2, _this$rootStore6$user3;

        var email, firstName, externalAccountID, lastName, username, phoneNumber, guestUserDataPayload, _yield$handle, _yield$handle2, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                email = (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : (_this$rootStore$user$ = _this$rootStore$user.userProfile) === null || _this$rootStore$user$ === void 0 ? void 0 : _this$rootStore$user$.login;
                firstName = (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : (_this$rootStore2$user2 = _this$rootStore2$user.userProfile) === null || _this$rootStore2$user2 === void 0 ? void 0 : _this$rootStore2$user2.firstName;
                externalAccountID = this === null || this === void 0 ? void 0 : (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : (_this$rootStore3$user2 = _this$rootStore3$user.userProfile) === null || _this$rootStore3$user2 === void 0 ? void 0 : _this$rootStore3$user2.userId;
                lastName = (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$user = _this$rootStore4.user) === null || _this$rootStore4$user === void 0 ? void 0 : (_this$rootStore4$user2 = _this$rootStore4$user.userProfile) === null || _this$rootStore4$user2 === void 0 ? void 0 : _this$rootStore4$user2.lastName;
                username = (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$user = _this$rootStore5.user) === null || _this$rootStore5$user === void 0 ? void 0 : (_this$rootStore5$user2 = _this$rootStore5$user.userProfile) === null || _this$rootStore5$user2 === void 0 ? void 0 : _this$rootStore5$user2.login;
                phoneNumber = (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$user = _this$rootStore6.user) === null || _this$rootStore6$user === void 0 ? void 0 : (_this$rootStore6$user2 = _this$rootStore6$user.userProfile) === null || _this$rootStore6$user2 === void 0 ? void 0 : (_this$rootStore6$user3 = _this$rootStore6$user2.defaultPhone) === null || _this$rootStore6$user3 === void 0 ? void 0 : _this$rootStore6$user3.phoneNumber;
                guestUserDataPayload = {
                  email: email,
                  firstName: firstName,
                  externalAccountID: externalAccountID,
                  lastName: lastName,
                  username: username,
                  phoneNumber: phoneNumber
                };
                _context6.prev = 7;
                _context6.next = 10;
                return handle(DPServices.WineLocker.guestAuthentication(guestUserDataPayload));

              case 10:
                _yield$handle = _context6.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                error = _yield$handle2[0];
                response = _yield$handle2[1];

                if (response) {
                  this.wineLockerModel.guestAuthDetails = response;
                }

                if (!error) {
                  _context6.next = 18;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.WINE_LOCKER_GUEST_AUTHENTICATION;
                throw errorDescription;

              case 18:
                _context6.next = 25;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t0 = _context6["catch"](7);
                console.warn(_context6.t0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context6.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context6.t0;

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[7, 20]]);
      }));

      function guestAuthentication() {
        return _guestAuthentication.apply(this, arguments);
      }

      return guestAuthentication;
    }()
  }, {
    key: "addWineToLocker",
    value: function () {
      var _addWineToLocker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload, selectedwineDetails) {
        var addWineToLockerPayload, _yield$handle3, _yield$handle4, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                addWineToLockerPayload = {
                  visibility: payload === null || payload === void 0 ? void 0 : payload.visibility,
                  lockerID: payload === null || payload === void 0 ? void 0 : payload.lockerID,
                  inRestaurant: payload === null || payload === void 0 ? void 0 : payload.inRestaurant,
                  count: payload === null || payload === void 0 ? void 0 : payload.count,
                  addStatus: payload === null || payload === void 0 ? void 0 : payload.addStatus,
                  venueWineID: payload === null || payload === void 0 ? void 0 : payload.venueWineID
                };
                _context7.prev = 1;
                _context7.next = 4;
                return handle(DPServices.WineLocker.addWineToLocker(addWineToLockerPayload, this.wineLockerModel.guestAuthDetails.token));

              case 4:
                _yield$handle3 = _context7.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                error = _yield$handle4[0];
                response = _yield$handle4[1];

                if (!error) {
                  _context7.next = 11;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.ADD_WINE_TO_LOCKER;
                throw errorDescription;

              case 11:
                if (!response) {
                  _context7.next = 14;
                  break;
                }

                this.rootStore.user.analyticsModel.dispatchWineLockerAddedItem(selectedwineDetails.name, selectedwineDetails.bottlePrice);
                return _context7.abrupt("return", response);

              case 14:
                _context7.next = 20;
                break;

              case 16:
                _context7.prev = 16;
                _context7.t0 = _context7["catch"](1);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context7.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context7.t0;

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 16]]);
      }));

      function addWineToLocker(_x2, _x3) {
        return _addWineToLocker.apply(this, arguments);
      }

      return addWineToLocker;
    }()
  }, {
    key: "addKeyholder",
    value: function () {
      var _addKeyholder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
        var _this$wineLockerModel, _this$wineLockerModel2, _this$wineLockerModel3, _payload$message;

        var addKeyholderPayload, _this$rootStore$user2, _this$rootStore$user3, _yield$handle5, _yield$handle6, error, response, userId, errorDescription;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.wineLockerModel.updatingKeyHolder = true;
                addKeyholderPayload = {
                  invitees: [{
                    email: (_this$wineLockerModel = this.wineLockerModel) === null || _this$wineLockerModel === void 0 ? void 0 : _this$wineLockerModel.keyHolderEmail,
                    firstName: (_this$wineLockerModel2 = this.wineLockerModel) === null || _this$wineLockerModel2 === void 0 ? void 0 : _this$wineLockerModel2.keyHolderFirstName,
                    lastName: (_this$wineLockerModel3 = this.wineLockerModel) === null || _this$wineLockerModel3 === void 0 ? void 0 : _this$wineLockerModel3.keyHolderLastName
                  }],
                  lockerID: this.wineLockerModel.wineLockerDetails.lockerID,
                  message: (_payload$message = payload === null || payload === void 0 ? void 0 : payload.message) !== null && _payload$message !== void 0 ? _payload$message : ""
                };
                _context8.prev = 2;
                _context8.next = 5;
                return handle(DPServices.WineLocker.addKeyholder(addKeyholderPayload, this.wineLockerModel.guestAuthDetails.token));

              case 5:
                _yield$handle5 = _context8.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                error = _yield$handle6[0];
                response = _yield$handle6[1];
                userId = (_this$rootStore$user2 = this.rootStore.user) === null || _this$rootStore$user2 === void 0 ? void 0 : (_this$rootStore$user3 = _this$rootStore$user2.userProfile) === null || _this$rootStore$user3 === void 0 ? void 0 : _this$rootStore$user3.userId;
                this.rootStore.user.analyticsModel.dispatchWineLockerAddedKeyholder(userId);
                _context8.next = 13;
                return this === null || this === void 0 ? void 0 : this.getWineLockerDetails(this.wineLockerModel.wineLockerDetails.lockerID);

              case 13:
                if (!error) {
                  _context8.next = 16;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.ADD_KEYHOLDER;
                throw errorDescription;

              case 16:
                if (!response) {
                  _context8.next = 18;
                  break;
                }

                return _context8.abrupt("return", response);

              case 18:
                _context8.next = 24;
                break;

              case 20:
                _context8.prev = 20;
                _context8.t0 = _context8["catch"](2);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context8.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context8.t0;

              case 24:
                _context8.prev = 24;
                this.wineLockerModel.updatingKeyHolder = false;
                return _context8.finish(24);

              case 27:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[2, 20, 24, 27]]);
      }));

      function addKeyholder(_x4) {
        return _addKeyholder.apply(this, arguments);
      }

      return addKeyholder;
    }()
  }, {
    key: "updateKeyholder",
    value: function () {
      var _updateKeyholder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
        var _this$wineLockerModel4, _this$wineLockerModel5;

        var lockerOwner, removeKeyholderPayload, _this$wineLockerModel6, _this$wineLockerModel7, _this$wineLockerModel8, _payload$message2, addKeyholderPayload, _yield$handle7, _yield$handle8, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.wineLockerModel.updatingKeyHolder = true;
                lockerOwner = (_this$wineLockerModel4 = this.wineLockerModel) === null || _this$wineLockerModel4 === void 0 ? void 0 : (_this$wineLockerModel5 = _this$wineLockerModel4.wineLockerDetails) === null || _this$wineLockerModel5 === void 0 ? void 0 : _this$wineLockerModel5.lockerOwners.find(function (owner) {
                  return owner.lockerOwnerType === "Primary";
                });
                removeKeyholderPayload = {
                  userID: payload.userID,
                  lockerOwnerID: lockerOwner === null || lockerOwner === void 0 ? void 0 : lockerOwner.userID,
                  lockerID: this.wineLockerModel.wineLockerDetails.lockerID
                };
                _context9.prev = 3;
                _context9.next = 6;
                return handle(DPServices.WineLocker.removeKeyholder(removeKeyholderPayload, this.wineLockerModel.guestAuthDetails.token));

              case 6:
                addKeyholderPayload = {
                  invitees: [{
                    email: ((_this$wineLockerModel6 = this.wineLockerModel) === null || _this$wineLockerModel6 === void 0 ? void 0 : _this$wineLockerModel6.keyHolderEmail) || "test2@t.com",
                    firstName: (_this$wineLockerModel7 = this.wineLockerModel) === null || _this$wineLockerModel7 === void 0 ? void 0 : _this$wineLockerModel7.keyHolderFirstName,
                    lastName: (_this$wineLockerModel8 = this.wineLockerModel) === null || _this$wineLockerModel8 === void 0 ? void 0 : _this$wineLockerModel8.keyHolderLastName
                  }],
                  lockerID: this.wineLockerModel.wineLockerDetails.lockerID,
                  message: (_payload$message2 = payload === null || payload === void 0 ? void 0 : payload.message) !== null && _payload$message2 !== void 0 ? _payload$message2 : ""
                };
                _context9.next = 9;
                return handle(DPServices.WineLocker.addKeyholder(addKeyholderPayload, this.wineLockerModel.guestAuthDetails.token));

              case 9:
                _yield$handle7 = _context9.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                error = _yield$handle8[0];
                response = _yield$handle8[1];
                _context9.next = 15;
                return this === null || this === void 0 ? void 0 : this.getWineLockerDetails(this.wineLockerModel.wineLockerDetails.lockerID);

              case 15:
                if (!error) {
                  _context9.next = 18;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.UPDATE_KEYHOLDER;
                throw errorDescription;

              case 18:
                if (!response) {
                  _context9.next = 20;
                  break;
                }

                return _context9.abrupt("return", response);

              case 20:
                _context9.next = 26;
                break;

              case 22:
                _context9.prev = 22;
                _context9.t0 = _context9["catch"](3);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context9.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context9.t0;

              case 26:
                _context9.prev = 26;
                this.wineLockerModel.updatingKeyHolder = false;
                return _context9.finish(26);

              case 29:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[3, 22, 26, 29]]);
      }));

      function updateKeyholder(_x5) {
        return _updateKeyholder.apply(this, arguments);
      }

      return updateKeyholder;
    }()
  }, {
    key: "removeKeyholder",
    value: function () {
      var _removeKeyholder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
        var _this$wineLockerModel9, _this$wineLockerModel10;

        var lockerOwner, removeKeyholderPayload, _yield$handle9, _yield$handle10, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.wineLockerModel.updatingKeyHolder = true;
                lockerOwner = (_this$wineLockerModel9 = this.wineLockerModel) === null || _this$wineLockerModel9 === void 0 ? void 0 : (_this$wineLockerModel10 = _this$wineLockerModel9.wineLockerDetails) === null || _this$wineLockerModel10 === void 0 ? void 0 : _this$wineLockerModel10.lockerOwners.find(function (owner) {
                  return owner.lockerOwnerType === "Primary";
                });
                removeKeyholderPayload = {
                  userID: payload.userID,
                  lockerOwnerID: lockerOwner === null || lockerOwner === void 0 ? void 0 : lockerOwner.userID,
                  lockerID: this.wineLockerModel.wineLockerDetails.lockerID
                };
                _context10.prev = 3;
                _context10.next = 6;
                return handle(DPServices.WineLocker.removeKeyholder(removeKeyholderPayload, this.wineLockerModel.guestAuthDetails.token));

              case 6:
                _yield$handle9 = _context10.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 2);
                error = _yield$handle10[0];
                response = _yield$handle10[1];
                _context10.next = 12;
                return this === null || this === void 0 ? void 0 : this.getWineLockerDetails(this.wineLockerModel.wineLockerDetails.lockerID);

              case 12:
                if (!error) {
                  _context10.next = 15;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.REMOVE_KEYHOLDER;
                throw errorDescription;

              case 15:
                if (!response) {
                  _context10.next = 17;
                  break;
                }

                return _context10.abrupt("return", response);

              case 17:
                _context10.next = 23;
                break;

              case 19:
                _context10.prev = 19;
                _context10.t0 = _context10["catch"](3);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context10.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context10.t0;

              case 23:
                _context10.prev = 23;
                this.wineLockerModel.updatingKeyHolder = false;
                return _context10.finish(23);

              case 26:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[3, 19, 23, 26]]);
      }));

      function removeKeyholder(_x6) {
        return _removeKeyholder.apply(this, arguments);
      }

      return removeKeyholder;
    }()
  }, {
    key: "getWineLockerDetails",
    value: function () {
      var _getWineLockerDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(lockerID) {
        var token, _yield$handle11, _yield$handle12, error, response, errorDescription, lockerWines, filteredWines, updatedResponse;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                token = this.wineLockerModel.guestAuthDetails.token;
                _context11.prev = 1;
                _context11.next = 4;
                return handle(DPServices.WineLocker.getWineLockerDetails(lockerID, token));

              case 4:
                _yield$handle11 = _context11.sent;
                _yield$handle12 = _slicedToArray(_yield$handle11, 2);
                error = _yield$handle12[0];
                response = _yield$handle12[1];

                if (!error) {
                  _context11.next = 11;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.GET_WINE_LOCKER_DETAILS_FAILED;
                throw errorDescription;

              case 11:
                if (response) {
                  lockerWines = response === null || response === void 0 ? void 0 : response.lockerWines;
                  filteredWines = lockerWines.reduce(function (result, wine) {
                    if (wine.addStatus === "Pending") {
                      result.pendingWines++;
                    } else if (wine.addStatus === "Confirmed") {
                      result.confirmedWines++;
                    }

                    return result;
                  }, {
                    pendingWines: 0,
                    confirmedWines: 0
                  });
                  updatedResponse = _objectSpread(_objectSpread({}, response), {}, {
                    pendingCount: filteredWines.pendingWines,
                    confirmedCount: filteredWines.confirmedWines
                  });
                  this.wineLockerModel.wineLockerDetails = updatedResponse;
                }

                _context11.next = 18;
                break;

              case 14:
                _context11.prev = 14;
                _context11.t0 = _context11["catch"](1);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context11.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context11.t0;

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 14]]);
      }));

      function getWineLockerDetails(_x7) {
        return _getWineLockerDetails.apply(this, arguments);
      }

      return getWineLockerDetails;
    }()
  }, {
    key: "getCurrentUserCurrentLocationWineLockers",
    value: function () {
      var _getCurrentUserCurrentLocationWineLockers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this3 = this;

        var _this$rootStore7, _this$rootStore7$menu, _this$rootStore7$menu2, _this$rootStore7$menu3, _this$wineLockerModel11, _this$wineLockerModel12, _this$wineLockerModel13, _this$wineLockerModel14, _this$wineLockerModel15, _this$wineLockerModel16, _this$wineLockerModel17, lockerOwnerID, _this$wineLockerModel18, _this$wineLockerModel19, _this$wineLockerModel20, _lockersAtCurrentLoca, lockersAtCurrentLocation, lockerID;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                this.wineLockerModel.wineLockerLoading = true;

                if (!(!((_this$rootStore7 = this.rootStore) !== null && _this$rootStore7 !== void 0 && (_this$rootStore7$menu = _this$rootStore7.menuList) !== null && _this$rootStore7$menu !== void 0 && (_this$rootStore7$menu2 = _this$rootStore7$menu.orderSettingsModel) !== null && _this$rootStore7$menu2 !== void 0 && (_this$rootStore7$menu3 = _this$rootStore7$menu2.currentRestaurant) !== null && _this$rootStore7$menu3 !== void 0 && _this$rootStore7$menu3.restaurantNumber) || !this.rootStore.user.isLoggedIn || !this.haveGuestDesignations())) {
                  _context12.next = 4;
                  break;
                }

                return _context12.abrupt("return");

              case 4:
                if (this !== null && this !== void 0 && (_this$wineLockerModel11 = this.wineLockerModel) !== null && _this$wineLockerModel11 !== void 0 && (_this$wineLockerModel12 = _this$wineLockerModel11.guestAuthDetails) !== null && _this$wineLockerModel12 !== void 0 && _this$wineLockerModel12.token) {
                  _context12.next = 7;
                  break;
                }

                _context12.next = 7;
                return this === null || this === void 0 ? void 0 : this.guestAuthentication();

              case 7:
                lockerOwnerID = this === null || this === void 0 ? void 0 : (_this$wineLockerModel13 = this.wineLockerModel) === null || _this$wineLockerModel13 === void 0 ? void 0 : (_this$wineLockerModel14 = _this$wineLockerModel13.guestAuthDetails) === null || _this$wineLockerModel14 === void 0 ? void 0 : _this$wineLockerModel14.userID;
                _context12.next = 10;
                return this === null || this === void 0 ? void 0 : this.getLockersByOwner(lockerOwnerID);

              case 10:
                if (!(this !== null && this !== void 0 && (_this$wineLockerModel15 = this.wineLockerModel) !== null && _this$wineLockerModel15 !== void 0 && (_this$wineLockerModel16 = _this$wineLockerModel15.wineLockersByOwner) !== null && _this$wineLockerModel16 !== void 0 && (_this$wineLockerModel17 = _this$wineLockerModel16.lockers) !== null && _this$wineLockerModel17 !== void 0 && _this$wineLockerModel17.length)) {
                  _context12.next = 22;
                  break;
                }

                lockersAtCurrentLocation = this === null || this === void 0 ? void 0 : (_this$wineLockerModel18 = this.wineLockerModel) === null || _this$wineLockerModel18 === void 0 ? void 0 : (_this$wineLockerModel19 = _this$wineLockerModel18.wineLockersByOwner) === null || _this$wineLockerModel19 === void 0 ? void 0 : (_this$wineLockerModel20 = _this$wineLockerModel19.lockers) === null || _this$wineLockerModel20 === void 0 ? void 0 : _this$wineLockerModel20.filter(function (locker) {
                  var _this3$rootStore, _this3$rootStore$menu, _this3$rootStore$menu2, _this3$rootStore$menu3;

                  return (locker === null || locker === void 0 ? void 0 : locker.locationID) === ( // this?.wineLockerModel?.restaurantDetails?.restaurantNum,
                  _this3 === null || _this3 === void 0 ? void 0 : (_this3$rootStore = _this3.rootStore) === null || _this3$rootStore === void 0 ? void 0 : (_this3$rootStore$menu = _this3$rootStore.menuList) === null || _this3$rootStore$menu === void 0 ? void 0 : (_this3$rootStore$menu2 = _this3$rootStore$menu.orderSettingsModel) === null || _this3$rootStore$menu2 === void 0 ? void 0 : (_this3$rootStore$menu3 = _this3$rootStore$menu2.currentRestaurant) === null || _this3$rootStore$menu3 === void 0 ? void 0 : _this3$rootStore$menu3.restaurantNumber);
                });
                lockerID = (_lockersAtCurrentLoca = lockersAtCurrentLocation[0]) === null || _lockersAtCurrentLoca === void 0 ? void 0 : _lockersAtCurrentLoca.lockerID; // TODO: need to ask and setup logic for if we will have only one locker at a place or multiple possible?

                if (!lockerID) {
                  _context12.next = 19;
                  break;
                }

                _context12.next = 16;
                return this === null || this === void 0 ? void 0 : this.getWineLockerDetails(lockerID);

              case 16:
                this.wineLockerModel.hasLockerAtCurrentLocation = true;
                _context12.next = 20;
                break;

              case 19:
                this.wineLockerModel.hasLockerAtCurrentLocation = false;

              case 20:
                _context12.next = 23;
                break;

              case 22:
                this.wineLockerModel.wineLockersByOwner = null;

              case 23:
                _context12.next = 29;
                break;

              case 25:
                _context12.prev = 25;
                _context12.t0 = _context12["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context12.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context12.t0;

              case 29:
                _context12.prev = 29;
                this.wineLockerModel.wineLockerLoading = false;
                return _context12.finish(29);

              case 32:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 25, 29, 32]]);
      }));

      function getCurrentUserCurrentLocationWineLockers() {
        return _getCurrentUserCurrentLocationWineLockers.apply(this, arguments);
      }

      return getCurrentUserCurrentLocationWineLockers;
    }()
  }, {
    key: "getLockersByLocation",
    value: function () {
      var _getLockersByLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(locationID) {
        var lockersByLocationPayload, _yield$handle13, _yield$handle14, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                lockersByLocationPayload = {
                  visibility: "Public",
                  // TODO: what if there is no location is selected and someone goes directly to wine locker flow, we wont have the location ID in that case which will break the flow
                  locationID: locationID,
                  populateWines: true
                };
                _context13.prev = 1;
                _context13.next = 4;
                return handle(DPServices.WineLocker.getLockersByLocation(lockersByLocationPayload));

              case 4:
                _yield$handle13 = _context13.sent;
                _yield$handle14 = _slicedToArray(_yield$handle13, 2);
                error = _yield$handle14[0];
                response = _yield$handle14[1];

                if (!error) {
                  _context13.next = 11;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.GET_WINE_LOCKERS_BY_LOCATION;
                throw errorDescription;

              case 11:
                if (response) {
                  this.wineLockerModel.wineLockersByLocation = response;
                }

                _context13.next = 18;
                break;

              case 14:
                _context13.prev = 14;
                _context13.t0 = _context13["catch"](1);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context13.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context13.t0;

              case 18:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[1, 14]]);
      }));

      function getLockersByLocation(_x8) {
        return _getLockersByLocation.apply(this, arguments);
      }

      return getLockersByLocation;
    }()
  }, {
    key: "cacheLockersByOwner",
    value: function () {
      var _cacheLockersByOwner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(lockers) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this.rootStore.platformUtil.saveInLocalStorage("LOCKERS_BY_OWNER", JSON.stringify(lockers)));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function cacheLockersByOwner(_x9) {
        return _cacheLockersByOwner.apply(this, arguments);
      }

      return cacheLockersByOwner;
    }()
  }, {
    key: "getLockersByOwner",
    value: function () {
      var _getLockersByOwner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(lockerOwnerID) {
        var lockersResponse, cachedResponse, _yield$handle15, _yield$handle16, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                lockersResponse = null;
                _context15.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("LOCKERS_BY_OWNER");

              case 4:
                cachedResponse = _context15.sent;

                if (cachedResponse) {
                  lockersResponse = JSON.parse(cachedResponse);
                }

                if (!lockersResponse) {
                  _context15.next = 10;
                  break;
                }

                this.wineLockerModel.wineLockersByOwner = lockersResponse;
                _context15.next = 20;
                break;

              case 10:
                _context15.next = 12;
                return handle(DPServices.WineLocker.getLockersByOwner(lockerOwnerID, this.wineLockerModel.guestAuthDetails.token));

              case 12:
                _yield$handle15 = _context15.sent;
                _yield$handle16 = _slicedToArray(_yield$handle15, 2);
                error = _yield$handle16[0];
                response = _yield$handle16[1];

                if (!error) {
                  _context15.next = 19;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.GET_WINE_LOCKERS_BY_OWNER;
                throw errorDescription;

              case 19:
                if (response) {
                  this.cacheLockersByOwner(response);
                  this.wineLockerModel.wineLockersByOwner = response;
                }

              case 20:
                _context15.next = 26;
                break;

              case 22:
                _context15.prev = 22;
                _context15.t0 = _context15["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context15.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context15.t0;

              case 26:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 22]]);
      }));

      function getLockersByOwner(_x10) {
        return _getLockersByOwner.apply(this, arguments);
      }

      return getLockersByOwner;
    }()
  }, {
    key: "haveGuestDesignations",
    value: function haveGuestDesignations() {
      var _this$rootStore8, _this$rootStore8$user, _this$rootStore8$user2, _this$rootStore8$user3, _this$rootStore8$user4;

      return (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$user = _this$rootStore8.user) === null || _this$rootStore8$user === void 0 ? void 0 : (_this$rootStore8$user2 = _this$rootStore8$user.userProfile) === null || _this$rootStore8$user2 === void 0 ? void 0 : (_this$rootStore8$user3 = _this$rootStore8$user2.guestDesignations) === null || _this$rootStore8$user3 === void 0 ? void 0 : (_this$rootStore8$user4 = _this$rootStore8$user3.find(function (designation) {
        return designation.name === "WineLockerHolder" || designation.name === "KeyHolder";
      })) === null || _this$rootStore8$user4 === void 0 ? void 0 : _this$rootStore8$user4.value;
    }
  }, {
    key: "createGift",
    value: function () {
      var _createGift = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _this$wineLockerModel21, _this$wineLockerModel22, giftDetails, promises, _i, _Object$values, wineGift, _yield$handle17, _yield$handle18, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                if (this !== null && this !== void 0 && (_this$wineLockerModel21 = this.wineLockerModel) !== null && _this$wineLockerModel21 !== void 0 && (_this$wineLockerModel22 = _this$wineLockerModel21.guestAuthDetails) !== null && _this$wineLockerModel22 !== void 0 && _this$wineLockerModel22.token) {
                  _context16.next = 4;
                  break;
                }

                _context16.next = 4;
                return this === null || this === void 0 ? void 0 : this.guestAuthentication();

              case 4:
                giftDetails = {
                  gifterUserID: this.wineLockerModel.guestAuthDetails.userID,
                  lockerID: this.wineLockerModel.wineLockerDetails.lockerID,
                  giftMessage: this.wineLockerModel.giftMessage
                };
                promises = [];
                _i = 0, _Object$values = Object.values(this.wineLockerModel.selectedWinesForGift);

              case 7:
                if (!(_i < _Object$values.length)) {
                  _context16.next = 18;
                  break;
                }

                wineGift = _Object$values[_i];

                if (!!this.wineLockerModel.gifteeEmail) {
                  giftDetails = _objectSpread(_objectSpread({}, giftDetails), {}, {
                    gifteeEmail: this.wineLockerModel.gifteeEmail,
                    recipientFirstName: this.wineLockerModel.recipientFirstName,
                    recipientLastName: this.wineLockerModel.recipientLastName,
                    bottleCount: wineGift.noOfBottles,
                    lockerWineIDs: [wineGift.lockerWineID]
                  });
                } else {
                  giftDetails = _objectSpread(_objectSpread({}, giftDetails), {}, {
                    recipientLockerID: Number(this.wineLockerModel.recipientLockerID),
                    bottleCount: wineGift.noOfBottles,
                    lockerWineIDs: [wineGift.lockerWineID]
                  });
                }

                _context16.t0 = promises;
                _context16.next = 13;
                return DPServices.WineLocker.createGift(giftDetails, this.wineLockerModel.guestAuthDetails.token);

              case 13:
                _context16.t1 = _context16.sent;

                _context16.t0.push.call(_context16.t0, _context16.t1);

              case 15:
                _i++;
                _context16.next = 7;
                break;

              case 18:
                _context16.next = 20;
                return handle(Promise.all(promises));

              case 20:
                _yield$handle17 = _context16.sent;
                _yield$handle18 = _slicedToArray(_yield$handle17, 2);
                error = _yield$handle18[0];
                response = _yield$handle18[1];

                if (!error) {
                  _context16.next = 27;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.WINE_LOCKER_CREATE_GIFT;
                throw errorDescription;

              case 27:
                if (response) {
                  this.rootStore.user.analyticsModel.dispatchWineLockerGiftItem(this.rootStore.user.userProfile.userId); // this.wineLockerModel.wineLockersByOwner = response;
                  // TODO: will be redirecting to confirmation screen
                }

                _context16.next = 34;
                break;

              case 30:
                _context16.prev = 30;
                _context16.t2 = _context16["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, "Your request to send a gift was not completed. Please try again.", null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context16.t2;

              case 34:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 30]]);
      }));

      function createGift() {
        return _createGift.apply(this, arguments);
      }

      return createGift;
    }()
  }, {
    key: "changeLockerVisibility",
    value: function () {
      var _changeLockerVisibility = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this$rootStore9, _this$rootStore9$wine, _this$rootStore9$wine2, _this$rootStore9$wine3, _this$rootStore10, _this$rootStore10$win, _this$rootStore10$win2, _this$rootStore10$win3;

        var lockerID, visibility, _yield$handle19, _yield$handle20, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                lockerID = (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$wine = _this$rootStore9.wineLocker) === null || _this$rootStore9$wine === void 0 ? void 0 : (_this$rootStore9$wine2 = _this$rootStore9$wine.wineLockerModel) === null || _this$rootStore9$wine2 === void 0 ? void 0 : (_this$rootStore9$wine3 = _this$rootStore9$wine2.wineLockerDetails) === null || _this$rootStore9$wine3 === void 0 ? void 0 : _this$rootStore9$wine3.lockerID;
                visibility = ((_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$win = _this$rootStore10.wineLocker) === null || _this$rootStore10$win === void 0 ? void 0 : (_this$rootStore10$win2 = _this$rootStore10$win.wineLockerModel) === null || _this$rootStore10$win2 === void 0 ? void 0 : (_this$rootStore10$win3 = _this$rootStore10$win2.wineLockerDetails) === null || _this$rootStore10$win3 === void 0 ? void 0 : _this$rootStore10$win3.visibility) === "Public" ? "Private" : "Public";
                _context17.prev = 2;
                _context17.next = 5;
                return handle(DPServices.WineLocker.changeLockerVisibility(lockerID, visibility, this.wineLockerModel.guestAuthDetails.token));

              case 5:
                _yield$handle19 = _context17.sent;
                _yield$handle20 = _slicedToArray(_yield$handle19, 2);
                error = _yield$handle20[0];
                response = _yield$handle20[1];

                if (!error) {
                  _context17.next = 12;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.WINE_LOCKER_VISIBILITY;
                throw errorDescription;

              case 12:
                if (!response) {
                  _context17.next = 14;
                  break;
                }

                return _context17.abrupt("return", response);

              case 14:
                _context17.next = 20;
                break;

              case 16:
                _context17.prev = 16;
                _context17.t0 = _context17["catch"](2);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context17.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context17.t0;

              case 20:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[2, 16]]);
      }));

      function changeLockerVisibility() {
        return _changeLockerVisibility.apply(this, arguments);
      }

      return changeLockerVisibility;
    }()
  }, {
    key: "addWineToGift",
    value: function addWineToGift(wine) {
      this.wineLockerModel.selectedWinesForGift = _objectSpread(_objectSpread({}, this.wineLockerModel.selectedWinesForGift), {}, _defineProperty({}, wine.lockerWineID, _objectSpread(_objectSpread({}, wine), {}, {
        noOfBottles: 1
      })));
    }
  }, {
    key: "updateNoOfBottles",
    value: function updateNoOfBottles(wineId, value) {
      var updatedObj = this.wineLockerModel.selectedWinesForGift;

      if (updatedObj.hasOwnProperty(wineId)) {
        if (updatedObj[wineId].noOfBottles > 0) {
          updatedObj[wineId].noOfBottles += value;
        }

        this.wineLockerModel.selectedWinesForGift = updatedObj;
      }
    }
  }, {
    key: "removeWineFromGift",
    value: function removeWineFromGift(id) {
      if (this.wineLockerModel.selectedWinesForGift.hasOwnProperty(id)) {
        delete this.wineLockerModel.selectedWinesForGift[id];
      }
    }
    /**
     * Adds unique history elements to the history array and adds quantity key for number of bottles
     * @param {WineLockerTypes.WineHistoryWithQuantity[]} array - Locker History Array.
     * @param {WineLockerTypes.WineHistory} wineHistoryEl - Single Wine history to be compared.
     * @returns {WineLockerTypes.WineHistoryWithQuantity[]} - updated History Array.
     */

  }, {
    key: "generateHistoryArray",
    value: function generateHistoryArray(array, wineHistoryEl) {
      var updatedArray = _toConsumableArray(array);

      var lockerWineID = wineHistoryEl.venueWineID;
      var index = updatedArray.findIndex(function (item) {
        return item.venueWineID === lockerWineID;
      });

      if (index !== -1) {
        var foundElement = updatedArray[index];
        foundElement.quantity++;
      } else {
        var wineHistoryWithQuantity = _objectSpread(_objectSpread({}, wineHistoryEl), {}, {
          quantity: 1
        });

        updatedArray.push(wineHistoryWithQuantity);
      }

      return updatedArray;
    }
  }, {
    key: "processWineLockerHistory",
    value: function processWineLockerHistory(historyResponse) {
      var _this4 = this;

      var allHistory = [];
      var consumedHistory = [];
      var purchasedHistory = [];
      historyResponse.wineHistory.forEach(function (wineHistoryEl) {
        //FOR CONSUMED SECTION
        if (wineHistoryEl.consumeStatus === WineLockerTypes.ConsumeStatus.Confirmed) {
          consumedHistory = _this4.generateHistoryArray(consumedHistory, wineHistoryEl);
        } // FOR PURCHASED SECTION


        if (wineHistoryEl.addStatus !== WineLockerTypes.Add.Denied) {
          purchasedHistory = _this4.generateHistoryArray(purchasedHistory, wineHistoryEl);
        } //FOR ALL SECTION


        allHistory = _this4.generateHistoryArray(allHistory, wineHistoryEl);
      }); //FOR GIFT SECTION

      this.wineLockerModel.lockerSentGifts = historyResponse.giftHistory || [];
      this.wineLockerModel.lockerAllHistory = allHistory;
      this.wineLockerModel.lockerConsumedHistory = consumedHistory;
      this.wineLockerModel.lockerPurchasedHistory = purchasedHistory;
      this.wineLockerModel.lockerReceivedGifts = historyResponse.receivedGiftHistory || [];
    }
  }, {
    key: "getWineLockerHistory",
    value: function () {
      var _getWineLockerHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var _this$rootStore11, _this$rootStore11$win, _this$rootStore11$win2, _this$rootStore11$win3, lockerID, _yield$handle21, _yield$handle22, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(this.wineLockerModel.lockerAllHistory !== null || this.wineLockerModel.lockerConsumedHistory !== null || this.wineLockerModel.lockerPurchasedHistory !== null || this.wineLockerModel.lockerSentGifts !== null || this.wineLockerModel.lockerReceivedGifts !== null)) {
                  _context18.next = 2;
                  break;
                }

                return _context18.abrupt("return");

              case 2:
                _context18.prev = 2;
                lockerID = (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$win = _this$rootStore11.wineLocker) === null || _this$rootStore11$win === void 0 ? void 0 : (_this$rootStore11$win2 = _this$rootStore11$win.wineLockerModel) === null || _this$rootStore11$win2 === void 0 ? void 0 : (_this$rootStore11$win3 = _this$rootStore11$win2.wineLockerDetails) === null || _this$rootStore11$win3 === void 0 ? void 0 : _this$rootStore11$win3.lockerID;
                _context18.next = 6;
                return handle(DPServices.WineLocker.getWineLockerHistory(lockerID, this.wineLockerModel.guestAuthDetails.token));

              case 6:
                _yield$handle21 = _context18.sent;
                _yield$handle22 = _slicedToArray(_yield$handle21, 2);
                error = _yield$handle22[0];
                response = _yield$handle22[1];

                if (!error) {
                  _context18.next = 13;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.WINE_LOCKER_HISTORY;
                throw errorDescription;

              case 13:
                if (response) {
                  this.processWineLockerHistory(response);
                }

                _context18.next = 19;
                break;

              case 16:
                _context18.prev = 16;
                _context18.t0 = _context18["catch"](2);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context18.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });

              case 19:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[2, 16]]);
      }));

      function getWineLockerHistory() {
        return _getWineLockerHistory.apply(this, arguments);
      }

      return getWineLockerHistory;
    }()
    /**
     * Adds unique wines to the gifted wines array, adds quantity key for
     * number of bottles and adds additional info not present if available in wine list response
     * @param {(WineLockerTypes.GiftWine & { quantity: number })[]} array - wines array.
     * @param {WineLockerTypes.GiftWine} wine - Single Wine to be compared.
     * @returns {(WineLockerTypes.GiftWine & { quantity: number })[]} - updated wines array.
     */

  }, {
    key: "generateGiftWinesArray",
    value: function generateGiftWinesArray(array, wine) {
      var winesList = this.rootStore.wineList.wineListModel.winesList.wines;

      var updatedArray = _toConsumableArray(array);

      var index = updatedArray.findIndex(function (item) {
        return item.genomeWineID === wine.genomeWineID;
      });

      if (index !== -1) {
        var foundElement = updatedArray[index];
        foundElement.quantity++;
      } else {
        var wineFoundInWineList = winesList.find(function (wine) {
          return wine.wineID === wine.genomeWineID;
        });

        var wineHistoryWithQuantity = _objectSpread(_objectSpread({}, wine), {}, {
          quantity: 1
        }, wineFoundInWineList);

        updatedArray.push(wineHistoryWithQuantity);
      }

      return updatedArray;
    }
  }, {
    key: "generateWinesArrayInWineGift",
    value: function generateWinesArrayInWineGift(giftWines) {
      var _this5 = this;

      var uniqueWinesArrayWithQuantity = [];
      giftWines.forEach(function (wine) {
        uniqueWinesArrayWithQuantity = _this5.generateGiftWinesArray(uniqueWinesArrayWithQuantity, wine);
      });
      return uniqueWinesArrayWithQuantity;
    }
  }, {
    key: "acceptGift",
    value: function () {
      var _acceptGift = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(giftID) {
        var _yield$handle23, _yield$handle24, error, response, errorDescription;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return handle(DPServices.WineLocker.acceptGift(giftID, "true", this.wineLockerModel.guestAuthDetails.token));

              case 3:
                _yield$handle23 = _context19.sent;
                _yield$handle24 = _slicedToArray(_yield$handle23, 2);
                error = _yield$handle24[0];
                response = _yield$handle24[1];

                if (!error) {
                  _context19.next = 10;
                  break;
                }

                errorDescription = DPServices.Common.checkAndGetErrorDescription(error) || Errors.ACCEPT_GIFT;
                throw errorDescription;

              case 10:
                if (response) {
                  //TODO
                  console.log(">>>response", response);
                }

                _context19.next = 17;
                break;

              case 13:
                _context19.prev = 13;
                _context19.t0 = _context19["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context19.t0.message, null, {
                  okBtnText: "Okay",
                  okBtnOnClick: function okBtnOnClick() {}
                });
                throw _context19.t0;

              case 17:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 13]]);
      }));

      function acceptGift(_x11) {
        return _acceptGift.apply(this, arguments);
      }

      return acceptGift;
    }()
  }]);

  return WineLocker;
}(Base), _applyDecoratedDescriptor(_class.prototype, "haveGuestDesignations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "haveGuestDesignations"), _class.prototype), _class);
export { WineLocker as default };